/* S-Method Custom Scripts */
(function() {
  'use strict';

  /* Scroll Reveal */
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  function initReveal() {
    document.querySelectorAll('.smethod-reveal').forEach(function(el) {
      observer.observe(el);
    });

    /* Staggered reveals within grids */
    document.querySelectorAll(
      '.smethod-points-grid .smethod-point-item, ' +
      '.smethod-products-grid .smethod-product-card, ' +
      '.smethod-steps-grid .smethod-step-item'
    ).forEach(function(el, i) {
      el.style.transitionDelay = (i * 0.1) + 's';
    });
  }

  /* Hero Copy Slider */
  function initHeroCopySlider() {
    var copies = document.querySelectorAll('.smethod-hero-copy');
    if (copies.length === 0) return;
  
    var current = 0;
    copies[0].classList.add('active');
  
    function slideup() {
      var prev = current;
      current = (current + 1) % copies.length;
  
      copies[prev].classList.remove('active');
      copies[prev].classList.add('exit');
  
      copies[current].classList.add('active');
  
      setTimeout(function() {
        copies[prev].classList.remove('exit');
      }, 400);
    }
  
    setInterval(slideup, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initReveal();
      initHeroCopySlider();
    });
  } else {
    initReveal();
    initHeroCopySlider();
  }

  /* Re-initialize on Shopify theme editor section events */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      initReveal();
      initHeroCopySlider();
    });
  }
})();
